<div mat-dialog-title class="pt-6! pb-0! px-6! before:h-0!" data-testid="change-organisation-dialog-title">
  <span class="text-xl py-2" data-testid="change-organisation">{{
    'navbar.user_menu.change_organisation' | translate
  }}</span>
</div>

<div mat-dialog-content class="px-6! py-4!">
  <mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic" data-testid="organisation-select">
    <mat-select
      [value]="selectedOrganisation"
      [compareWith]="compareOrganisations"
      (selectionChange)="selectedOrganisation = $event.value"
      data-testid="change-organisation-select">
      @for (org of data.organisations; track org.id) {
        <mat-option [value]="org">{{ org.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

<mat-dialog-actions class="px-6! pb-6! pt-0! gap-4">
  <claas-button [buttonClass]="buttonClass.SECONDARY_TEXT" mat-dialog-close data-testid="change-organisation-cancel">
    {{ 'global.cancel' | translate }}
  </claas-button>
  <claas-button (click)="onChange()" data-testid="change-organisation-confirm">
    {{ 'navbar.change_organisation.confirm' | translate }}
  </claas-button>
</mat-dialog-actions>
